<template>
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M23.5019 45.0027C23.8997 45.0027 24.2813 44.8446 24.5626 44.5633C24.8439 44.282 25.0019 43.9005 25.0019 43.5027V8.12368L34.4399 17.5647C34.7216 17.8463 35.1036 18.0046 35.5019 18.0046C35.9002 18.0046 36.2822 17.8463 36.5639 17.5647C36.8456 17.283 37.0038 16.901 37.0038 16.5027C37.0038 16.1044 36.8456 15.7223 36.5639 15.4407L24.5639 3.44068C24.4246 3.30099 24.259 3.19016 24.0768 3.11454C23.8946 3.03892 23.6992 3 23.5019 3C23.3046 3 23.1092 3.03892 22.927 3.11454C22.7448 3.19016 22.5792 3.30099 22.4399 3.44068L10.4399 15.4407C10.3004 15.5801 10.1898 15.7457 10.1143 15.9279C10.0388 16.1101 10 16.3054 10 16.5027C10 16.901 10.1582 17.283 10.4399 17.5647C10.7216 17.8463 11.1036 18.0046 11.5019 18.0046C11.9002 18.0046 12.2822 17.8463 12.5639 17.5647L22.0019 8.12368V43.5027C22.0019 43.9005 22.1599 44.282 22.4412 44.5633C22.7225 44.8446 23.1041 45.0027 23.5019 45.0027Z" fill="currentColor"/>
    </svg>
</template>

<script>
export default {
    name: 'SVGArrowTooltipUp',
};
</script>

<style scoped lang="scss">

</style>
